import { SKILL_IDS, STRATEGY_IDS } from "../constants.ts";
import type { AchievementCatalog } from "./achievement.ts";

export const ACHIEVEMENT_CATALOG_VERSION = "reken-achievements-v1";

export const ACHIEVEMENT_CATALOG: AchievementCatalog = {
  version: ACHIEVEMENT_CATALOG_VERSION,
  cards: [
    {
      id: "REKEN.017.BASE",
      achievementId: "CROSS_10_ADD.STRATEGY_INDEPENDENT",
      collectionNumber: "017",
      tier: "BASE",
      title: "Bruggenbouwer",
      earnedCopy: "Je kunt over 10 optellen door eerst 10 te maken.",
      lockedHint: "Leer zelf over 10 optellen.",
      secret: false,
      condition: {
        kind: "STRATEGY_STAGE_AT_LEAST",
        strategyId: STRATEGY_IDS.VIA_10_ADD,
        stage: "INDEPENDENT",
      },
    },
    {
      id: "REKEN.017.FOIL",
      achievementId: "CROSS_10_ADD.CAN_DO",
      collectionNumber: "017",
      tier: "FOIL",
      title: "Bruggenbouwer",
      earnedCopy: "Je beheerst steeds meer optelsommen over 10 zelfstandig.",
      lockedHint: "Word sterker in optellen over 10.",
      secret: false,
      condition: {
        kind: "SKILL_STAGE_AT_LEAST",
        skillId: SKILL_IDS.CROSS_10_ADD,
        stage: "CAN_DO",
      },
    },
    {
      id: "REKEN.017.HOLO",
      achievementId: "CROSS_10_ADD.DURABLE_MASTERY",
      collectionNumber: "017",
      tier: "HOLO",
      title: "Bruggenbouwer",
      earnedCopy: "Je kent de strategie én veel optelsommen over 10 meteen.",
      lockedHint: null,
      secret: true,
      condition: {
        kind: "ALL",
        conditions: [
          {
            kind: "SKILL_STAGE_AT_LEAST",
            skillId: SKILL_IDS.CROSS_10_ADD,
            stage: "KNOWS_IMMEDIATELY",
          },
          {
            kind: "STRATEGY_STAGE_AT_LEAST",
            strategyId: STRATEGY_IDS.VIA_10_ADD,
            stage: "STABLE",
          },
        ],
      },
    },
    {
      id: "REKEN.017.GOLD",
      achievementId: "CROSS_10_ADD.TRANSFER",
      collectionNumber: "017",
      tier: "GOLD",
      title: "Bruggenbouwer",
      earnedCopy: "Je gebruikte jouw over-10-kennis ook bij grotere getallen.",
      lockedHint: null,
      secret: true,
      condition: {
        kind: "ALL",
        conditions: [
          {
            kind: "SKILL_STAGE_AT_LEAST",
            skillId: SKILL_IDS.CROSS_10_ADD,
            stage: "KNOWS_IMMEDIATELY",
          },
          {
            kind: "TRANSFER_SUCCESSES",
            sourceSkillId: SKILL_IDS.CROSS_10_ADD,
            successCount: 3,
            distinctSessionCount: 2,
          },
        ],
      },
    },
  ],
};
